var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchool = function SvgSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M50 25.09c0 13.808-11.193 25-25 25s-25-11.192-25-25 11.193-25 25-25 25 11.193 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8.366 20.168 16.178-6.183 17.09 6.183-17.09 6.69zm33.268 0v7.395"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.095 22.537v10.462s2.676 3.197 10.45 3.197c7.772 0 10.331-2.903 10.331-2.903v-6.941"
  }))));
};
export default SvgSchool;